import client from './client';

export const adminsApi = {
  getAll: (params) => client.get('/admins', { params }),
  getById: (id) => client.get(`/admins/${id}`),
  create: (data) => client.post('/admins', data),
  update: (id, data) => client.put(`/admins/${id}`, data),
  toggleActive: (id) => client.put(`/admins/${id}/toggle-active`),
  sendResetEmail: (id) => client.post(`/admins/${id}/send-reset-email`),
  delete: (id) => client.delete(`/admins/${id}`)
};
